import {
  Autocomplete,
  Box,
  Button,
  Grid,
  InputAdornment,
  TextField,
  useTheme
} from "@mui/material"
import { ArrowDown2, Calendar, CloseCircle } from "iconsax-react"
import { useEffect, useState } from "react"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { Controller, useForm } from "react-hook-form"
import DatePicker from "react-multi-date-picker"
import TransactionServices from "../../../../services/transactions"
import { onlyDigitsWithMaxLen } from "../../../common/inputs/helper"
import { ButtonContainer, DatePickerContainer } from "../transactions.styles"

const TransactionsFilter = ({ submitForm }) => {
  const theme = useTheme()
  const {
    register,
    reset,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm()

  const p2e = s => s.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
  /**
   * States and Effects and Hooks
   * _______________________________________________________________________________
   */

  const [type, setType] = useState([])

  /**
   * Methods
   * _______________________________________________________________________________
   */

  useEffect(() => {
    TransactionServices.getTransactionTypeFilter().then(response => {
      if (response?.status === 200) {
        if (!response?.data?.succeed) {
          toast.error(response?.data?.message)
        } else {
          setType(response?.data?.value)
        }
      }
    })
  }, [])

  return (
    <Box sx={{ p: 2 }}>
      <form onSubmit={handleSubmit(submitForm)}>
        <Grid container spacing={1} alignItems='center'>
          {type && (
            <Grid item xs={12} md={3}>
              <Controller
                control={control}
                name='type'
                rules={{
                  required: {
                    value: false
                  }
                }}
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    onChange={(event, item) => {
                      onChange(item)
                    }}
                    value={value || ""}
                    options={type}
                    clearIcon={<CloseCircle size={18} />}
                    popupIcon={<ArrowDown2 size={18} />}
                    getOptionLabel={item => (item.name ? item.name : "")}
                    renderInput={params => (
                      <TextField
                        {...params}
                        size='small'
                        label='نوع تراکنش'
                        inputProps={{
                          ...params.inputProps,
                          maxLength: 10
                        }}
                      />
                    )}
                  />
                )}
              />
            </Grid>
          )}

          <DatePickerContainer item xs={12} md={3}>
            <Controller
              control={control}
              name='startDate'
              className='tesy'
              render={({ field: { onChange, name, value } }) => (
                <>
                  <DatePicker
                    className='red'
                    calendar={persian}
                    locale={persian_fa}
                    value={value || ""}
                    onChange={date => {
                      onChange(date?.isValid ? p2e(date.format("YYYY/MM/DD")) : "")
                    }}
                    render={
                      <TextField
                        onKeyDown={onlyDigitsWithMaxLen(10)}
                        name={name}
                        inputProps={{ maxLength: 10 }}
                        size='small'
                        fullWidth
                        label='از تاریخ'
                        value={""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position='end'>
                              <Calendar size={18} />
                            </InputAdornment>
                          )
                        }}
                      />
                    }
                  />
                </>
              )}
            />
          </DatePickerContainer>

          <DatePickerContainer item xs={12} md={3}>
            <Controller
              control={control}
              name='endDate'
              render={({ field: { onChange, name, value } }) => (
                <>
                  <DatePicker
                    className='red'
                    calendar={persian}
                    locale={persian_fa}
                    value={value || ""}
                    onChange={date => {
                      onChange(date?.isValid ? p2e(date.format("YYYY/MM/DD")) : "")
                    }}
                    render={
                      <TextField
                        onKeyDown={onlyDigitsWithMaxLen(10)}
                        name={name}
                        inputProps={{ maxLength: 10 }}
                        size='small'
                        fullWidth
                        label='تا تاریخ'
                        value={""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position='end'>
                              <Calendar size={18} />
                            </InputAdornment>
                          )
                        }}
                      />
                    }
                  />
                </>
              )}
            />
          </DatePickerContainer>

          <Grid item xs={12} md={3}>
            <ButtonContainer direction='row' justifyContent='center' spacing={1} alignItems='center'>
              <Button
                className='small'
                fullWidth
                type='submit'
                disableElevation
                size='small'
                variant='contained'
                color='info'
              >
                جستجو
              </Button>
              <Button
                onClick={() => {
                  submitForm({})
                  reset()
                }}
                fullWidth
                variant='contained'
                size='small'
                color='primary'
                disableElevation
              >
                پاک کردن فیلترها
              </Button>
            </ButtonContainer>
          </Grid>
        </Grid>
      </form>
    </Box>
  )
}

export default TransactionsFilter
